import { createClient } from "contentful";
import Show from "../model/Show";
import BlogPost from "../model/BlogPost";

class ContentfulUtil {
  constructor() {
    if (ContentfulUtil.instance) {
      throw new Error("New instance cannot be created!!");
    }

    this.client = createClient({
      space: 'ae4cmm9kc6vt',
      accessToken: 'LVhchEDWOi01FWZzEnDUz__D-jWownviI7Yl_9Pv3fw',
    });

    ContentfulUtil.instance = this;
    this.currentSeason = null;
    this.pastSeason = null;
    this.futureSeason = null;
    this.boardMembers = null;
    this.sponsors = null;
    this.nonShowEvents = null;
  }

  getClient() {
    return this.client;
  }

  #isPublished(entity) {
    return !!entity.fields
  }

  async getCurrentSeason() {
    if (this.currentSeason) {
      return this.currentSeason;
    }

    try {
      const entries = await this.client.getEntries({
        content_type: 'season',
        'fields.currentSeason': true
      });

      const season = [];
      for (const entry of entries.items) {
        for (const show of entry.fields.shows) {
          if (this.#isPublished(show)){
            season.push(new Show(show))
          } 
        }
      }

      this.currentSeason = season;
      return this.currentSeason;
    } catch (error) {
      console.error('Error retrieving current season:', error);
      return null;
    }
  }

  async getPastSeasonsByStatus() {
    if (this.pastSeason) {
      return this.pastSeason;
    }

    try {
      const entries = await this.client.getEntries({
          content_type: 'season',
          order: 'fields.seasonTitle',
          'fields.seasonStatus2': 'Past'
      }).then(function (entries) {
          return entries.items.reverse()
      });

      return entries;
    } catch (error) {
      console.error('Error retrieving past season:', error);
      return null;
    }
  }

  async getCurrentSeasonByStatus() {
    if (this.currentSeason) {
      return this.currentSeason;
    }

    try {
      const entries = await this.client.getEntries({
        content_type: 'season',
        'fields.seasonStatus2': 'Current'
      });

      const season = [];
      for (const entry of entries.items) {
        for (const show of entry.fields.shows) {
          if (this.#isPublished(show)){
            season.push(new Show(show))
          } 
        }
      }

      this.currentSeason = season;
      return this.currentSeason;
    } catch (error) {
      console.error('Error retrieving current season:', error);
      return null;
    }
  }

  async getFutureSeasonByStatus() {
    if (this.futureSeason) {
      return this.futureSeason;
    }

    try {
      const entries = await this.client.getEntries({
        content_type: 'season',
        'fields.seasonStatus2': 'Future'
      });

      const season = [];
      for (const entry of entries.items) {
        for (const show of entry.fields.shows) {
          if (this.#isPublished(show)){
            season.push(new Show(show))
          } 
        }
      }

      this.futureSeason = season;
      return this.futureSeason;
    } catch (error) {
      console.error('Error retrieving future season:', error);
      return null;
    }
  }

async getNonShowEvents() {
  const entries = await this.client.getEntries({
    content_type: 'nonShowEvents'
  });

  console.log("NON-SHOW RAW CONTENTFUL:", entries);

  return entries.items;
}

  async getBoardMembers() {
    if (this.boardMembers) {
      return this.boardMembers;
    }

    try {
      const entries = await this.client.getEntries({
        content_type: 'crew',
        order: 'fields.order',
      });

      const members = [];
      for (const entry of entries.items) {
        if (this.#isPublished(entry)){
          members.push(entry.fields)
        } 
      }

      this.boardMembers = members;
      return this.boardMembers;
    } catch (error) {
      console.error('Error retrieving board members:', error);
      return null;
    }
  }

  async getSponsors() {
    console.log("Pre")
    if (this.sponsors) {
      return this.sponsors;
    }

    try {
      const entries = await this.client.getEntries({
        content_type: 'sponsor'
      });

      const donors = [];
      
      console.log("entries",entries)

      for (const entry of entries.items) {
        if (this.#isPublished(entry)){
          donors.push(entry.fields)
        } 
      }

      this.sponsors = donors;
      
      console.log("Post")
      return this.sponsors;
    } catch (error) {
      console.error('Error retrieving sponsors:', error);
      return null;
    }
  }

  async getBlogPosts() {
    try {
      const entries = await this.client.getEntries({
        content_type: 'blogPost',
        order: '-fields.publishDate,-sys.createdAt'
      });

      const posts = [];
      for (const entry of entries.items) {
        if (this.#isPublished(entry)) {
          posts.push(new BlogPost(entry));
        }
      }
      posts.sort((a, b) => b.publishDate - a.publishDate);
      return posts;
    } catch (error) {
      console.warn('Contentful blog retrieval warning:', error?.message || error);
      try {
        const fallbackEntries = await this.client.getEntries({
          content_type: 'blogPost'
        });
        const posts = [];
        for (const entry of fallbackEntries.items) {
          if (this.#isPublished(entry)) {
            posts.push(new BlogPost(entry));
          }
        }
        posts.sort((a, b) => b.publishDate - a.publishDate);
        return posts;
      } catch (fallbackError) {
        console.error('Failed to retrieve blog posts:', fallbackError);
        return [];
      }
    }
  }

  async getBlogPostBySlug(slug) {
    try {
      const entries = await this.client.getEntries({
        content_type: 'blogPost',
        'fields.slug': slug,
        limit: 1
      });

      if (entries.items && entries.items.length > 0) {
        return new BlogPost(entries.items[0]);
      }

      // Fallback: Check if slug matches entry ID
      try {
        const singleEntry = await this.client.getEntry(slug);
        if (singleEntry && this.#isPublished(singleEntry)) {
          return new BlogPost(singleEntry);
        }
      } catch (idErr) {
        // Entry ID lookup failed or not found
      }
    } catch (error) {
      console.warn(`Error querying Contentful for blog post with slug ${slug}:`, error?.message || error);
    }

    return null;
  }
}

const instance = new ContentfulUtil();
export default instance;
